import { apiClient } from '../../../api/client'
import { downloadXlsx } from '../../../lib/download'
import type { MeetingType, MeetingTypePage, MeetingTypeStatus, MeetingTypeUpsert } from '../types'

const BASE = '/management/meeting-types'

/**
 * Silinmemiş kayıtların listesi. Lookup ölçeği küçük (bugün 16 satır) → tek sayfada çekilir.
 *
 * `q` adda arar ve **sunucuda** süzülür: TR-farkında karşılaştırma (`i` ↔ `İ`) orada yazılı,
 * istemcide ikinci bir kopyası tutulmaz.
 */
export async function getMeetingTypes(q?: string): Promise<MeetingTypePage> {
  const { data } = await apiClient.get<MeetingTypePage>(BASE, {
    params: { page: 0, size: 200, ...(q ? { q } : {}) },
  })
  return data
}

/** Yeni kayıt (201 → oluşturulan kayıt). */
export async function createMeetingType(body: MeetingTypeUpsert): Promise<MeetingType> {
  const { data } = await apiClient.post<MeetingType>(BASE, body)
  return data
}

/** Kaydı güncelle (adlar; optimistic lock için `modDate` zorunlu). */
export async function updateMeetingType(id: number, body: MeetingTypeUpsert): Promise<MeetingType> {
  const { data } = await apiClient.put<MeetingType>(`${BASE}/${id}`, body)
  return data
}

/** Durum değiştir (Aktif/Pasif; yalnız 0↔1). */
export async function changeMeetingTypeStatus(
  id: number,
  body: MeetingTypeStatus,
): Promise<MeetingType> {
  const { data } = await apiClient.put<MeetingType>(`${BASE}/${id}/status`, body)
  return data
}

/** Soft-delete (record_status=2). 204. */
export async function deleteMeetingType(id: number): Promise<void> {
  await apiClient.delete(`${BASE}/${id}`)
}

/**
 * Listeyi Excel (.xlsx) olarak indirir — sunucu tüm kayıtları sayfalamadan akıtır; indirme mekaniği ve
 * dosya adı ortak {@link downloadXlsx} yardımcısındadır.
 */
export async function exportMeetingTypes(q?: string): Promise<void> {
  await downloadXlsx(`${BASE}/export`, q ? { q } : {}, 'toplanti-turleri.xlsx')
}
